// extracted by mini-css-extract-plugin
export default {"wrapper":"Shell--wrapper__VPMCYC"};